<!--
RowBox.vue
수평 배치 전용 컨테이너 컴포넌트

📌 Props
- vAlign: "start" | "center" | "end"
- hAlign: "start" | "center" | "end"

📌 예시
<RowBox vAlign="center" hAlign="start">
  <div>내용</div>
</RowBox>

-->
<template>
  <div :class="classes">
    <slot />
  </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  vAlign: {
    type: String,
    default: "center", // top, center, bottom
  },
  hAlign: {
    type: String,
    default: "start", // left, center, right
  },
});

const classes = computed(() => {
  return [
    "row-box",
    `v-${props.vAlign}`,
    `h-${props.hAlign}`,
  ];
});
</script>

<style scoped>
.row-box {
  display: flex;
  flex-direction: row;
}

/* Vertical alignment */
.v-start {
  align-items: flex-start;
}
.v-center {
  align-items: center;
}
.v-end {
  align-items: flex-end;
}

/* Horizontal alignment */
.h-start {
  justify-content: flex-start;
}
.h-center {
  justify-content: center;
}
.h-end {
  justify-content: flex-end;
}
</style>
